
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

/**
 * ViewUpi component displays user-entered and UPI-verified details for review.
 * Provides navigation and formatted display of UPI information.
 */
const ViewUpi = ({ login = null }) => {
  const location = useLocation();
  const gpaydetails = location.state?.gpaydetails || "";

  const id = location.state?.id || "";


  const navigate = useNavigate();

  function formatKey(key) {
    // Split the key by underscores, capitalize each part, and join with spaces
    return key
      .replace(/nameAtBank/g, "Name at Bank")
      .replace(/accountExists/g, "Account Exists")
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-check.png")}
              />
              <h6 className="mt-5">UPI is Valid</h6>
            </div>

            <div className="px-5">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>UPI ID</label>
              <p>{id}</p>
            </div>
            <div className="card_data">
              <h6>Details As Per The UPI</h6>
              <div className="d-flex flex-wrap">
                <div className="details_card">
                  {typeof gpaydetails === "object" &&
                    Object.entries(gpaydetails).map(([key, value]) => (
                      <div key={key}>
                        <label>{formatKey(key)}:</label> <p>{value}</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="btns cn-btn mt-15 d-flex">
              {/* <Link to={`${redirectUrl}/add-upi/${userId}`}> */}
              <button
                className="btn bgdark-blue text-white"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              {/* </Link> */}
              {/* <Link to={`${redirectUrl}/upi-details-success/${userId}`}>
                <button className="btn red-btn text-white">Submit</button>
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewUpi